import { createContext, useContext } from "react";
import type { TermsType } from "@/api/types";

export interface CheckAndPromptOptions {
  checkAsUser?: boolean;
}

export interface TermsContextType {
  checkAndPrompt: (
    walletAddress: string | undefined,
    termsType: TermsType,
    options?: CheckAndPromptOptions
  ) => Promise<boolean>;
  clearCache: () => void;
}

export const TermsContext = createContext<TermsContextType | null>(null);

export function useTermsContext() {
  const context = useContext(TermsContext);
  if (!context) {
    throw new Error("useTermsContext must be used within TermsProvider");
  }
  return context;
}
